module.exports = __webpack_public_path__ + "img/luggage_768.2500114d.png";